import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../customs/skeleton/main";


const Main = lazy(() => import("../../components/members/individuals/main"));


const Individuals = () => {

    return(
        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>    
    )
};

export default Individuals;